import localization from './localization'
import measurements from '../reducers/measurements'
import { getGlasslMaterial } from '../reducers/materialStore';


const buildDoorName = (state) => {
    let result = "";
    switch (state.measurements.doorType) {
        case 'customGlassWall':
            result = "E-mittaovi " + getGlasslMaterial(state,state.measurements.glassMaterial).name;
            break;
        case 'doorWithCarms':
            result = "Tervalepp� karmiovi " + getGlasslMaterial(state, state.measurements.glassMaterial).name;
            break;
    }
    return result;

}
export default buildDoorName;